// import { ProgramSessionSetCreateRequest, SetSearchFilter, ProgramSessionSetSearchResponse, ProgramSessionSet } from '@api/entities';
import { SetTransitByExerciseRequest, SetTransitByExerciseResponse } from 'src/api/entities';
import { IWorkoutSessionSetTransitApiService, WorkoutSessionSetTransitApiService } from '../services/workoutSesssionSetTransit/workout.session.set.transit.api.service';

export interface IWorkoutSessionSetTransitManager {
    transitBySession(request: SetTransitByExerciseRequest): Promise<SetTransitByExerciseResponse>;
}

export class WorkoutSessionSetTransitManager implements IWorkoutSessionSetTransitManager {
    private static instance: WorkoutSessionSetTransitManager;
    private workoutService: IWorkoutSessionSetTransitApiService;

    private constructor() {
        this.workoutService = WorkoutSessionSetTransitApiService.getInstance(process.env.REACT_APP_MICROSERVICE_AUTH_BASEPATH!);
    }

    static getInstance() {
        if (WorkoutSessionSetTransitManager.instance == null) {
            WorkoutSessionSetTransitManager.instance = new WorkoutSessionSetTransitManager();
        }
        return WorkoutSessionSetTransitManager.instance;
    }

    async transitBySession(request: SetTransitByExerciseRequest): Promise<SetTransitByExerciseResponse> {
        const response = await this.workoutService.transitBySession(request)
        return response;
    }
}
